import type { CoursesLesson } from "@/react/types/CoursesLesson";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { Modal } from "@circle-react-uikit/ModalV2";
import { MODAL_SIZES } from "@circle-react-uikit/ModalV2/ModalContent";
import { Content } from "./Content";

interface AutoadvanceLessonModalProps {
  currentLesson: CoursesLesson;
  navigateToNextLesson: () => any;
  nextLesson: CoursesLesson;
}
export const AutoadvanceLessonModalComponent = ({
  currentLesson,
  navigateToNextLesson,
  nextLesson,
}: AutoadvanceLessonModalProps) => {
  const modal = useModal();

  return (
    <Modal
      isOpen={modal.visible}
      onClose={modal.remove}
      contentPortalId={`autocomplete-lesson-modal-portal-${currentLesson.id}`}
    >
      <Modal.Overlay />
      <Modal.Content size={MODAL_SIZES.sm}>
        <Content
          navigateToNextLesson={navigateToNextLesson}
          nextLesson={nextLesson}
          removeModal={modal.remove}
        />
      </Modal.Content>
    </Modal>
  );
};
const AutoadvanceLessonModal = ModalManager.create(
  (props: AutoadvanceLessonModalProps) => (
    <AutoadvanceLessonModalComponent {...props} />
  ),
);
export const useAutoadvanceLessonModal = () => useModal(AutoadvanceLessonModal);
